function decorateBreadcrumb(vm, baseRoute, breadcrumbs) {
  if (!vm.currentAssetType || !vm.currentAsset) {
    return;
  }

  breadcrumbs.push(
    {
      pageName: vm.currentAssetType.name,
      routeName: `${baseRoute}`,
      noTranslate: true,
      params: vm.$route.params,
    },
    {
      pageName: vm.currentAsset.name,
      routeName: `${baseRoute}`,
      noTranslate: true,
      params: vm.$route.params,
    },
  );
}

export default (vm, baseRoute) => ({
  'decorate-breadcrumb': ({ breadcrumbs }) => decorateBreadcrumb(vm, baseRoute, breadcrumbs),
});
